module.exports = require("./lib/_stream_passthrough.js")



/*****************
 ** WEBPACK FOOTER
 ** (webpack)/~/node-libs-browser/~/readable-stream/passthrough.js
 ** module id = 298
 ** module chunks = 46 47
 **/